module.exports = __webpack_public_path__ + "img/box1_bg.9e850953.jpg";